import { useParams } from 'react-router-dom';
import { CurriculumOverviewTable } from '../../../../../components/Curricula/Tables/CurriculumOverviewTable';

export const CurriculumGradeSubpage = () => {
  const { curriculumUuid, grade } = useParams();

  return <CurriculumOverviewTable curriculumUuid={curriculumUuid ?? ''} grade={grade} />;
};
